// ── Native API base URL ───────────────────────────────────────────────────────
// The Android app's own WebView isn't the deployed site — it loads bundled
// assets locally, so a plain relative fetch('/api/...') has nowhere to land:
// the WebView silently serves its own fallback page with a 200 status instead
// of erroring, which makes a failed call look like a success. The native
// build needs the real deployment origin prefixed on every /api/... call.
// Same fix already used by src/google/calendar.js's apiUrl() — REACT_APP_APP_URL
// is documented in .env.example (Google Calendar section) and is public-safe.
import { Capacitor } from '@capacitor/core';

const APP_ORIGIN = process.env.REACT_APP_APP_URL || '';

export function apiUrl(path) {
  return Capacitor.isNativePlatform() ? `${APP_ORIGIN}${path}` : path;
}
